// @ts-nocheck 5975c1f3
import * as addPanel from '#packages/oldAddPanel';

export default {
  getDesignSections() {
    return {
      titles: ['mobilemenu_design_section_explore'],
      sections: [
        addPanel.sections.getSections().designPanelOnly.tinyMenuStyleSection,
      ],
    };
  },
};
